import { fromJS } from 'immutable';
// Action types
import {
  FETCH_PROGRAM_DATA_REQUEST,
  FETCH_PROGRAM_DATA_SUCCESS,
  FETCH_PROGRAM_DATA_FAILURE,
  FETCH_CONTENT_LIBRARY_REQUEST,
  FETCH_CONTENT_LIBRARY_SUCCESS,
  FETCH_CONTENT_LIBRARY_FAILURE,
  HANDLE_SELECT,
  HANDLE_DROP_REQUEST,
  HANDLE_DROP_SUCCESS,
  HANDLE_DROP_FAILURE,
  UPDATE_WORKSPACE_DATA,
  PROCESS_DATA_REQUEST,
  PROCESS_DATA_SUCCESS,
  PROCESS_DATA_FAILURE,
  HANDLE_REMOVE_REQUEST,
  HANDLE_REMOVE_SUCCESS,
  HANDLE_REMOVE_FAILURE,
  INCREMENT_VIEW_ZOOM,
  DECREMENT_VIEW_ZOOM,
  ENABLE_IS_DRAGGING,
  DISABLE_IS_DRAGGING,
  SAVE_WORK_STATE,
  UNDO_WORK_STATE,
  REDO_WORK_STATE,
  HANDLE_CHANGE_PROPERTIES,
  RESET_CURRENT_NODE_SELECTED,
  FETCH_EVENT_DATA_REQUEST,
  FETCH_EVENT_DATA_SUCCESS,
  FETCH_EVENT_DATA_FAILURE,
  CREATE_EVENT_REQUEST,
  CREATE_EVENT_SUCCESS,
  CREATE_EVENT_FAILURE,
  UPDATE_EVENT_REQUEST,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EVENT_FAILURE,
  TOGGLE_EVENT_MODAL,
  DELETE_EVENT_REQUEST,
  DELETE_EVENT_SUCCESS,
  DELETE_EVENT_FAILURE,
  TOGGLE_ERROR_MODAL,
  UNDO_REQUEST,
  REDO_REQUEST,
  SAVE_PROGRAM_REQUEST,
  SAVE_PROGRAM_SUCCESS,
  SAVE_PROGRAM_FAILURE,
  TOGGLE_DRAGGING,
  HANDLE_CHANGE_SEARCH,
  FETCH_BROADCAST_DATA_REQUEST,
  FETCH_BROADCAST_DATA_SUCCESS,
  FETCH_BROADCAST_DATA_FAILURE,
  SAVE_BROADCAST_REQUEST,
  SAVE_BROADCAST_SUCCESS,
  SAVE_BROADCAST_FAILURE,
  SEARCH_CONTENT_REQUEST,
  SEARCH_CONTENT_SUCCESS,
  SEARCH_CONTENT_FAILURE,
  UPDATE_CONTENT_REQUEST,
  UPDATE_CONTENT_SUCCESS,
  UPDATE_CONTENT_FAILURE,
  UPDATE_EVENTS_DATA,
  FETCH_DESKTOP_PLAYER_REQUEST,
  FETCH_DESKTOP_PLAYER_SUCCESS,
  FETCH_DESKTOP_PLAYER_FAILURE,
  TOGGLE_CHOOSE_EVENT_MODAL,
  TOGGLE_PREVIEW_MODAL,
  SET_EDITOR_MODE,
  TOGGLE_EVENT_COLLAPSE,
  FETCH_AUDIENCES_SUCCESS,
  FETCH_AUDIENCES_REQUEST,
  FETCH_AUDIENCES_FAILURE,
  FETCH_AUTOMATED_BROADCAST_REQUEST,
  FETCH_AUTOMATED_BROADCAST_SUCCESS,
  FETCH_AUTOMATED_BROADCAST_FAILURE,
  SHOW_ERROR,
  FETCH_TENANT_SETTINGS_REQUEST,
  FETCH_TENANT_SETTINGS_SUCCESS, FETCH_TENANT_SETTINGS_FAILURE
} from './constants';

// CTA types
import {
  CTA_ACTIVATE_BROADCAST,
  CTA_CALL,
  CTA_CUSTOM,
  CTA_EMAIL, CTA_JOIN_SEGMENT, CTA_OTHER_CONTENT,
  CTA_OWN_ANCHOR,
  CTA_TRIGGER_EVENT,
  CTA_WEBSITE, NODE_END_OF_CONTENT, NODE_INIT
} from '../../constants/ItemTypes';

import * as ctaActions from '../../constants/CTATypes';

import * as Icons from '../../constants/ImagesUrl';
import { BROADCAST_MODE } from '../../constants/EditorMode';

// Initial state
const initialState = fromJS({
  editorMode: '',
  workspaceData: {},
  contentLibrary: [],
  eventData: [],
  programDataFetched: false,
  isFetchingProgram: false,
  isFetchingContents: false,
  isInProcessing: true,
  isFetchingEvent: false,
  isCreatingEvent: false,
  isUpdatingContent: false,
  isUpdatingEvent: {
    status: false,
    id: ''
  },
  isDeletingEvent: false,
  isSavingProgram: false,
  isGlobalDragging: false,
  isOpenEventModal: false,
  isOpenErrorModal: false,
  appError: {},
  currentNodeSelected: {},
  listEventsCreated: [],
  workspaceHistory: {
    limit: 100,
    currentIndex: 0,
    canUndo: false,
    canRedo: false,
    datas: [],
    listEventsRemoved: []
  },
  viewZoom: 100,
  isSaving: false,
  saved: false,
  searchText: '',
  searchResult: [],
  isSearching: false,
  desktopPlayerData: {},
  isFetchingDesktopPlayer: false,
  isOpenChooseEventModal: false,
  isOpenPreviewModal: false,
  isFetchingAudiences: false,
  isFetchingAutomatedBroadcast: false,
  audiences: [],
  automatedBroadcasts: [],
  tenantSettings: [],
  isFetchingTenantSettings: false,
  ctaActions: [
    {
      id: 'program-cta-01',
      type: CTA_WEBSITE,
      imgUrl: Icons.ICON_CTA_WEBSITE,
      linkTo: {
        action: ctaActions.WEBSITE,
        url: ''
      },
      title: 'Website',
      desc: 'Opens a given website'
    },
    {
      id: 'program-cta-02',
      type: CTA_EMAIL,
      linkTo: {
        action: ctaActions.MAIL,
        mail: {
          email: '',
          subject: ''
        }
      },
      imgUrl: Icons.ICON_CTA_EMAIL,
      title: 'Email',
      desc: 'Send an e-mail to a given address with optionally a predefined subject'
    },
    {
      id: 'program-cta-03',
      type: CTA_CALL,
      imgUrl: Icons.ICON_CTA_CALL,
      linkTo: {
        action: ctaActions.CALL,
        call: ''
      },
      title: 'Call',
      desc: 'Prepares a call to a given telephone number'
    },
    {
      id: 'program-cta-04',
      type: CTA_OWN_ANCHOR,
      imgUrl: Icons.ICON_CTA_OWN_ANCHOR,
      linkTo: {
        action: ctaActions.OWN_ANCHOR,
        ownAnchor: ''
      },
      title: 'Bookmark',
      desc: 'Jump back and forth to a bookmark in the video'
    },
    {
      id: 'program-cta-05',
      type: CTA_TRIGGER_EVENT,
      imgUrl: Icons.ICON_CTA_TRIGGER,
      linkTo: {
        action: ctaActions.TRIGGER_EVENT,
        eventId: ''
      },
      title: 'Event',
      desc: 'Trigger a defined event, this will play the content'
    },
    {
      id: 'program-cta-06',
      type: CTA_CUSTOM,
      imgUrl: Icons.ICON_CTA_CUSTOM,
      linkTo: {
        action: ctaActions.CUSTOM_CTA,
        customCTA: ''
      },
      title: 'Custom Action',
      desc: 'Trigger a custom action in the SDK so that the app can take action onto this. This option only is needed for connect with other SDK\'s functionalities in app'
    },
    {
      id: 'program-cta-07',
      type: CTA_JOIN_SEGMENT,
      imgUrl: Icons.ICON_JOIN_SEGMENT,
      linkTo: {
        action: ctaActions.JOIN_SEGMENT,
        segment: ''
      },
      title: 'Join Audience',
      desc: 'Join Audience'
    },
    {
      id: 'program-cta-08',
      type: CTA_ACTIVATE_BROADCAST,
      imgUrl: Icons.ICON_CTA_ACTIVATE_BROADCAST,
      linkTo: {
        action: ctaActions.ACTIVATE_BROADCAST,
        broadcast: ''
      },
      title: 'Activate Automated Broadcast',
      desc: 'Activate Automated Broadcast'
    }
  ]
});

/**
 * Main reducer
 * @param state
 * @param action
 * @returns {*}
 */
export default (state = initialState, action) => {
  switch (action.type) {
    // Set editor mode
    case SET_EDITOR_MODE:
      return state.set('editorMode', action.payload.editorMode);

    // Fetch program data
    case FETCH_PROGRAM_DATA_REQUEST:
      return state
        .set('workspaceData', fromJS({}))
        .set('isFetchingProgram', true)
        .set('isInProcessing', true);
    case FETCH_PROGRAM_DATA_SUCCESS:
      return state
        .set('workspaceData', fromJS(action.workspaceData))
        .set('isFetchingProgram', false)
        .set('isInProcessing', false);
    case FETCH_PROGRAM_DATA_FAILURE:
      return state
        .set('isFetchingProgram', false)
        .set('isInProcessing', false)
        .set('appError', fromJS(action.appError))
        .set('isOpenErrorModal', true);

    // Fetch broadcast data
    case FETCH_BROADCAST_DATA_REQUEST:
      return state
        .set('workspaceData', fromJS({}))
        .set('isFetchingProgram', true)
        .set('isInProcessing', true);
    case FETCH_BROADCAST_DATA_SUCCESS:
      return state
        .set('workspaceData', fromJS(action.workspaceData))
        .set('isFetchingProgram', false)
        .set('isInProcessing', false);
    case FETCH_BROADCAST_DATA_FAILURE:
      return state
        .set('isFetchingProgram', false)
        .set('isInProcessing', false)
        .set('appError', fromJS(action.appError))
        .set('isOpenErrorModal', true);

    // Fetch content library
    case FETCH_CONTENT_LIBRARY_REQUEST:
      return state
        .set('contentLibrary', fromJS([]))
        .set('isFetchingContents', true)
        .set('isInProcessing', true);
    case FETCH_CONTENT_LIBRARY_SUCCESS:
      return state
        .set('contentLibrary', fromJS(action.contentLibrary))
        .set('searchResult', fromJS(action.contentLibrary))
        .set('isFetchingContents', false)
        .set('isInProcessing', false);
    case FETCH_CONTENT_LIBRARY_FAILURE:
      return state
        .set('isFetchingContents', false)
        .set('isInProcessing', false)
        .set('appError', fromJS(action.appError))
        .set('isOpenErrorModal', true);

    // Save program data
    case SAVE_PROGRAM_REQUEST:
      return state
        .set('isSavingProgram', true)
        .set('isInProcessing', true);
    case SAVE_PROGRAM_SUCCESS:
      return state
        .set('isSavingProgram', false)
        .set('isInProcessing', false);
    case SAVE_PROGRAM_FAILURE:
      return state
        .set('isSavingProgram', false)
        .set('isInProcessing', false)
        .set('appError', fromJS(action.appError))
        .set('isOpenErrorModal', true);

    // Save broadcast data
    case SAVE_BROADCAST_REQUEST:
      return state
        .set('isSavingProgram', true)
        .set('isInProcessing', true);
    case SAVE_BROADCAST_SUCCESS:
      return state
        .set('isSavingProgram', false)
        .set('isInProcessing', false);
    case SAVE_BROADCAST_FAILURE:
      return state
        .set('isSavingProgram', false)
        .set('isInProcessing', false)
        .set('appError', fromJS(action.appError))
        .set('isOpenErrorModal', true);

    // Fetch event data
    case FETCH_EVENT_DATA_REQUEST:
      return state
        .set('eventData', fromJS([]))
        .set('isFetchingEvent', true)
        .set('isInProcessing', true);
    case FETCH_EVENT_DATA_SUCCESS:
      return state
        .set('eventData', fromJS(action.eventData))
        .set('isFetchingEvent', false)
        .set('isInProcessing', false);
    case FETCH_EVENT_DATA_FAILURE:
      return state
        .set('isFetchingEvent', false)
        .set('isInProcessing', false)
        .set('appError', fromJS(action.appError))
        .set('isOpenErrorModal', true);
    // Create new event
    case CREATE_EVENT_REQUEST:
      return state
        .set('isCreatingEvent', true)
        .set('isInProcessing', true)
        .set('isOpenEventModal', false);
    case CREATE_EVENT_SUCCESS:
      return state
        .updateIn(['workspaceData', 'events'], arr => arr.push(fromJS({
          id: action.eventData.id,
          name: action.eventData.name,
          contents: []
        })))
        .update('listEventsCreated', arr => arr.push(fromJS({
          id: action.eventData.id,
          name: action.eventData.name
        })))
        .set('isCreatingEvent', false)
        .set('isInProcessing', false)
        .set('isOpenEventModal', false);
    case CREATE_EVENT_FAILURE:
      return state
        .set('isCreatingEvent', false)
        .set('isInProcessing', false)
        .set('appError', fromJS(action.appError))
        .set('isOpenEventModal', false)
        .set('isOpenErrorModal', true);
    // Delete event
    case DELETE_EVENT_REQUEST:
      return state
        .set('isUpdatingEvent', fromJS({
          status: true,
          id: action.payload.eventId
        }))
        .set('isInProcessing', true);
    case DELETE_EVENT_SUCCESS:
      return state
        .deleteIn(['workspaceData', 'events', action.payload.eventIndex])
        .updateIn(['workspaceHistory', 'listEventsRemoved'], arr => arr.push(action.payload.eventId))
        .set('isUpdatingEvent', fromJS({
          status: false,
          id: action.payload.eventId
        }))
        .set('isInProcessing', false)
        .set('isOpenEventModal', false);
    case DELETE_EVENT_FAILURE:
      return state
        .set('isInProcessing', false)
        .set('isUpdatingEvent', fromJS({
          status: false,
          id: ''
        }))
        .set('appError', fromJS(action.appError))
        .set('isOpenErrorModal', true);
    // Update event data
    case UPDATE_EVENT_REQUEST:
      return state
        .set('isUpdatingEvent', fromJS({
          status: true,
          id: action.payload.eventId
        }))
        .set('isInProcessing', true);
    case UPDATE_EVENT_SUCCESS: {
      if (action.payload.editorMode && action.payload.editorMode === BROADCAST_MODE) {
        return state
          .setIn(['workspaceData', 'events', action.payload.eventIndex, 'name'], action.payload.newName)
          .setIn(['workspaceData', 'name'], action.payload.newName)
          .setIn(['workspaceData', 'title'], action.payload.newName)
          .set('isUpdatingEvent', fromJS({
            status: false,
            id: action.payload.eventId
          }))
          .set('isInProcessing', false)
          .set('isOpenEventModal', false);
      }
      return state
        .setIn(['workspaceData', 'events', action.payload.eventIndex, 'name'], action.payload.newName)
        .set('isUpdatingEvent', fromJS({
          status: false,
          id: action.payload.eventId
        }))
        .set('isInProcessing', false)
        .set('isOpenEventModal', false);
    }
    case UPDATE_EVENT_FAILURE:
      return state
        .set('isUpdatingEvent', fromJS({
          status: false,
          id: ''
        }))
        .set('isInProcessing', false)
        .set('appError', fromJS(action.appError))
        .set('isOpenErrorModal', true);

    // Process data
    case PROCESS_DATA_REQUEST:
      return state
        .set('isInProcessing', true);
    case PROCESS_DATA_SUCCESS:
      return state
        .set('isInProcessing', false);
    case PROCESS_DATA_FAILURE:
      return state
        .set('isInProcessing', false)
        .set('appError', fromJS(action.appError))
        .set('isOpenErrorModal', true);

    // Handle select
    case HANDLE_SELECT:
      if (action.currentNodeSelected.itemType === CTA_OTHER_CONTENT &&
        action.currentNodeSelected.nodeType !== NODE_INIT) {
        // Case 1: Node item is a CTA_OTHER_CONTENT
        const anchorSelected = state.getIn(['workspaceData',
          'events', action.currentNodeSelected.positionParent[0],
          'contents', action.currentNodeSelected.positionParent[1],
          'endOfContent', 'content', 'anchor']);
        return state
          .set('currentNodeSelected', fromJS(action.currentNodeSelected))
          .setIn(['currentNodeSelected', 'anchorSelected'], anchorSelected);
      } else if (action.currentNodeSelected.itemType === CTA_OWN_ANCHOR) {
        // Case 2: Node item is a CTA_OWN_ANCHOR
        const anchors = state.getIn(['workspaceData',
          'events', action.currentNodeSelected.positionParent[0],
          'contents', action.currentNodeSelected.positionParent[1],
          'anchors']);
        return state
          .set('currentNodeSelected', fromJS(action.currentNodeSelected))
          .setIn(['currentNodeSelected', 'anchors'], anchors);
      }
      return state
        .set('currentNodeSelected', fromJS(action.currentNodeSelected));

    // Handle drop
    case HANDLE_DROP_REQUEST:
      return state
        .set('isInProcessing', true);
    case HANDLE_DROP_SUCCESS:
      return state
        .setIn(['workspaceData', 'events'], fromJS(action.newEvents))
        .set('isInProcessing', false);
    case HANDLE_DROP_FAILURE:
      return state
        .set('isInProcessing', false)
        .set('appError', fromJS(action.appError))
        .set('isOpenErrorModal', true);

    // Handle remove
    case HANDLE_REMOVE_REQUEST:
      return state
        .set('isInProcessing', true);
    case HANDLE_REMOVE_SUCCESS:
      return state
        .setIn(['workspaceData', 'events'], fromJS(action.newEvents))
        .set('isInProcessing', false);
    case HANDLE_REMOVE_FAILURE:
      return state
        .set('isInProcessing', false)
        .set('appError', fromJS(action.appError))
        .set('isOpenErrorModal', true);

    // Update workspace data
    case UPDATE_WORKSPACE_DATA: {
      const events = state.getIn(['workspaceData', 'events']).toJS();
      // Loop events
      for (let i = 0; i < events.length; i += 1) {
        const positionNode = [i];
        // Add positionNode to event
        events[i].positionNode = [...positionNode];

        // Loop contents
        for (let j = 0; j < events[i].contents.length; j += 1) {
          // Add positionNode to content
          positionNode.push(j);
          events[i].contents[j].positionNode = [...positionNode];

          // Check the current Node dropped's id and update sqoonyNodeSelected
          // (Select node after drop)
          if (events[i].contents[j].id === window.sqoonyNodeDroppedId) {
            window.sqoonyNodeSelected = {
              ...window.sqoonyNodeSelected,
              positionNode: events[i].contents[j].positionNode
            };
            delete window.sqoonyNodeDroppedId;
          }

          // Add positionNode to content -> endOfContent
          if (events[i].contents[j].endOfContent) {
            events[i].contents[j].endOfContent.positionNode = [...positionNode];
          }

          // Loop ctas
          for (let k = 0; k < events[i].contents[j].ctas.length; k += 1) {
            // Add positionNode to cta
            positionNode.push(k);
            events[i].contents[j].ctas[k].positionNode = [...positionNode];
            positionNode.pop();
          }
          positionNode.pop();
        }
      }
      return state.mergeIn(['workspaceData', 'events'], fromJS(events));
    }

    // Increment view zoom
    case INCREMENT_VIEW_ZOOM:
      if (state.get('viewZoom') < 200) {
        return state.set('viewZoom', state.get('viewZoom') + 10);
      }
      return state;

    // Decrement view zoom
    case DECREMENT_VIEW_ZOOM:
      if (state.get('viewZoom') > 30) {
        return state.set('viewZoom', state.get('viewZoom') - 10);
      }
      return state;

    // Save work state
    case SAVE_WORK_STATE:
      // console.log('SAVED', state.getIn(['workspaceHistory', 'listEventsRemoved']).toJS());
      if (state.getIn(['workspaceHistory', 'datas']).size === 0) {
        return state
          .setIn(['workspaceHistory', 'currentIndex'], state.getIn(['workspaceHistory', 'currentIndex']) + 1)
          .updateIn(['workspaceHistory', 'datas'], arr => arr.push(state.get('workspaceData')));
      } else if (state.getIn(['workspaceHistory', 'currentIndex']) === state.getIn(['workspaceHistory', 'datas']).size &&
        state.getIn(['workspaceHistory', 'datas']).size < state.getIn(['workspaceHistory', 'limit'])) {
        return state
          .setIn(['workspaceHistory', 'currentIndex'], state.getIn(['workspaceHistory', 'currentIndex']) + 1)
          .setIn(['workspaceHistory', 'canUndo'], true)
          .setIn(['workspaceHistory', 'canRedo'], false)
          .updateIn(['workspaceHistory', 'datas'], arr => arr.push(state.get('workspaceData')));
      } else if (state.getIn(['workspaceHistory', 'currentIndex']) !== state.getIn(['workspaceHistory', 'datas']).size &&
        state.getIn(['workspaceHistory', 'datas']).size < state.getIn(['workspaceHistory', 'limit'])) {
        return state
          .setIn(['workspaceHistory', 'currentIndex'], state.getIn(['workspaceHistory', 'currentIndex']) + 1)
          .setIn(['workspaceHistory', 'canUndo'], true)
          .setIn(['workspaceHistory', 'canRedo'], false)
          .setIn(
            ['workspaceHistory', 'datas'],
            state.getIn(['workspaceHistory', 'datas'])
              .filter((data, index) => index < state.getIn(['workspaceHistory', 'currentIndex']))
          )
          .updateIn(['workspaceHistory', 'datas'], arr => arr.push(state.get('workspaceData')));
      } else if (state.getIn(['workspaceHistory', 'currentIndex']) !== state.getIn(['workspaceHistory', 'datas']).size &&
        state.getIn(['workspaceHistory', 'datas']).size === state.getIn(['workspaceHistory', 'limit'])) {
        return state
          .setIn(['workspaceHistory', 'currentIndex'], state.getIn(['workspaceHistory', 'currentIndex']) + 1)
          .setIn(['workspaceHistory', 'canUndo'], true)
          .setIn(['workspaceHistory', 'canRedo'], false)
          .setIn(
            ['workspaceHistory', 'datas'],
            state.getIn(['workspaceHistory', 'datas'])
              .filter((data, index) => index < state.getIn(['workspaceHistory', 'currentIndex']))
          )
          .updateIn(['workspaceHistory', 'datas'], arr => arr.push(state.get('workspaceData')));
      }
      return state
        .setIn(['workspaceHistory', 'currentIndex'], state.getIn(['workspaceHistory', 'currentIndex']))
        .setIn(['workspaceHistory', 'canUndo'], true)
        .setIn(['workspaceHistory', 'canRedo'], false)
        .deleteIn(['workspaceHistory', 'datas', 1])
        .updateIn(['workspaceHistory', 'datas'], arr => arr.push(state.get('workspaceData')));

    // Undo request
    case UNDO_REQUEST:
      return state.set('isUpdatingEvent', fromJS({
        status: true,
        id: action.payload.eventId
      }));

    // Undo work state
    case UNDO_WORK_STATE:
      if (state.getIn(['workspaceHistory', 'currentIndex']) === 2) {
        // Check if undo is UNDO_DELETE => update eventId
        if (action.payload.id) {
          return state
            .set('currentNodeSelected', fromJS({}))
            .setIn(['workspaceHistory', 'currentIndex'], state.getIn(['workspaceHistory', 'currentIndex']) - 1)
            .setIn(['workspaceHistory', 'canUndo'], false)
            .setIn(['workspaceHistory', 'canRedo'], true)
            .setIn([
              'workspaceHistory',
              'datas', state.getIn(['workspaceHistory', 'currentIndex']) - 2,
              'events', action.payload.positionNode[0],
              'id'
            ], action.payload.id)
            .set('workspaceData',
              state.getIn(['workspaceHistory', 'datas', state.getIn(['workspaceHistory', 'currentIndex']) - 2]))
            .setIn([
              'workspaceData',
              'events', action.payload.positionNode[0],
              'id'
            ], action.payload.id)
            .set('isUpdatingEvent', fromJS({
              status: false,
              id: action.payload.id
            }));
        }
        // Undo is UNDO_NORMAL, UNDO_UPDATE, UNDO_CREATE
        return state
          .set('currentNodeSelected', fromJS({}))
          .setIn(['workspaceHistory', 'currentIndex'], state.getIn(['workspaceHistory', 'currentIndex']) - 1)
          .setIn(['workspaceHistory', 'canUndo'], false)
          .setIn(['workspaceHistory', 'canRedo'], true)
          .set('workspaceData',
            state.getIn(['workspaceHistory', 'datas', state.getIn(['workspaceHistory', 'currentIndex']) - 2]))
          .set('isUpdatingEvent', fromJS({
            status: false,
            id: action.payload.id
          }));
      } else if (state.getIn(['workspaceHistory', 'currentIndex']) > 2) {
        // Check if undo is UNDO_DELETE => update eventId
        if (action.payload.id) {
          return state
            .set('currentNodeSelected', fromJS({}))
            .setIn(['workspaceHistory', 'currentIndex'], state.getIn(['workspaceHistory', 'currentIndex']) - 1)
            .setIn(['workspaceHistory', 'canRedo'], true)
            .setIn([
              'workspaceHistory',
              'datas', state.getIn(['workspaceHistory', 'currentIndex']) - 2,
              'events', action.payload.positionNode[0],
              'id'
            ], action.payload.id)
            .set('workspaceData',
              state.getIn(['workspaceHistory', 'datas', state.getIn(['workspaceHistory', 'currentIndex']) - 2]))
            .setIn([
              'workspaceData',
              'events', action.payload.positionNode[0],
              'id'
            ], action.payload.id)
            .set('isUpdatingEvent', fromJS({
              status: false,
              id: action.payload.id
            }));
        }
        // Undo is UNDO_NORMAL, UNDO_UPDATE, UNDO_CREATE
        return state
          .set('currentNodeSelected', fromJS({}))
          .setIn(['workspaceHistory', 'currentIndex'], state.getIn(['workspaceHistory', 'currentIndex']) - 1)
          .setIn(['workspaceHistory', 'canRedo'], true)
          .set('workspaceData',
            state.getIn(['workspaceHistory', 'datas', state.getIn(['workspaceHistory', 'currentIndex']) - 2]))
          .set('isUpdatingEvent', fromJS({
            status: false,
            id: action.payload.id
          }));
      }
      return state;

    // Redo request
    case REDO_REQUEST:
      return state.set('isUpdatingEvent', fromJS({
        status: true,
        id: action.payload.eventId
      }));

    // Redo work state
    case REDO_WORK_STATE:
      if (state.getIn(['workspaceHistory', 'currentIndex']) === state.getIn(['workspaceHistory', 'datas']).size - 1) {
        // Check if undo is REDO_CREATE => update eventId
        if (action.payload.id) {
          return state
            .set('currentNodeSelected', fromJS({}))
            .setIn(['workspaceHistory', 'currentIndex'], state.getIn(['workspaceHistory', 'currentIndex']) + 1)
            .setIn(['workspaceHistory', 'canUndo'], true)
            .setIn(['workspaceHistory', 'canRedo'], false)
            .setIn([
              'workspaceHistory',
              'datas', state.getIn(['workspaceHistory', 'currentIndex']),
              'events', action.payload.positionNode[0],
              'id'
            ], action.payload.id)
            .set('workspaceData',
              state.getIn(['workspaceHistory', 'datas', state.getIn(['workspaceHistory', 'currentIndex'])]))
            .setIn([
              'workspaceData',
              'events', action.payload.positionNode[0],
              'id'
            ], action.payload.id)
            .set('isUpdatingEvent', fromJS({
              status: false,
              id: action.payload.id
            }));
        }
        // Redo is REDO_NORMAL, REDO_UPDATE, REDO_UPDATE
        return state
          .set('currentNodeSelected', fromJS({}))
          .setIn(['workspaceHistory', 'currentIndex'], state.getIn(['workspaceHistory', 'currentIndex']) + 1)
          .setIn(['workspaceHistory', 'canUndo'], true)
          .setIn(['workspaceHistory', 'canRedo'], false)
          .set('workspaceData',
            state.getIn(['workspaceHistory', 'datas', state.getIn(['workspaceHistory', 'currentIndex'])]))
          .set('isUpdatingEvent', fromJS({
            status: false,
            id: action.payload.id
          }));
      } else if (state.getIn(['workspaceHistory', 'currentIndex']) < state.getIn(['workspaceHistory', 'datas']).size) {
        // Check if undo is REDO_CREATE => update eventId
        if (action.payload.id) {
          return state
            .set('currentNodeSelected', fromJS({}))
            .setIn(['workspaceHistory', 'currentIndex'], state.getIn(['workspaceHistory', 'currentIndex']) + 1)
            .setIn(['workspaceHistory', 'canUndo'], true)
            .setIn([
              'workspaceHistory',
              'datas', state.getIn(['workspaceHistory', 'currentIndex']),
              'events', action.payload.positionNode[0],
              'id'
            ], action.payload.id)
            .set('workspaceData',
              state.getIn(['workspaceHistory', 'datas', state.getIn(['workspaceHistory', 'currentIndex'])]))
            .setIn([
              'workspaceData',
              'events', action.payload.positionNode[0],
              'id'
            ], action.payload.id)
            .set('isUpdatingEvent', fromJS({
              status: false,
              id: action.payload.id
            }));
        }
        // Redo is REDO_NORMAL, REDO_UPDATE, REDO_UPDATE
        return state
          .set('currentNodeSelected', fromJS({}))
          .setIn(['workspaceHistory', 'currentIndex'], state.getIn(['workspaceHistory', 'currentIndex']) + 1)
          .setIn(['workspaceHistory', 'canUndo'], true)
          .set('workspaceData',
            state.getIn(['workspaceHistory', 'datas', state.getIn(['workspaceHistory', 'currentIndex'])]))
          .set('isUpdatingEvent', fromJS({
            status: false,
            id: action.payload.id
          }));
      }
      return state;

    // Enable isDragging
    case ENABLE_IS_DRAGGING:
      return state.set('isGlobalDragging', true);

    // Disable isDragging
    case DISABLE_IS_DRAGGING:
      return state.set('isGlobalDragging', false);

    // Reset currentNodeSelected
    case RESET_CURRENT_NODE_SELECTED:
      return state.set('currentNodeSelected', fromJS({}));

    // Handle change Contextual box properties
    case HANDLE_CHANGE_PROPERTIES: {
      const positionNode = state.getIn(['currentNodeSelected', 'positionNode']).toJS();
      const positionParent = state.getIn(['currentNodeSelected', 'positionParent']).toJS();
      // Content, endOfContent
      if (positionNode.length === 2) {
        switch (action.payload.target.name) {
          // Content - Available at
          case 'available-at':
            // Reset delay when change available-at
            if (action.payload.target.value === 'relative') {
              return state
                .setIn(['workspaceData',
                  'events', positionNode[0],
                  'contents', positionNode[1],
                  'availableAtDetails', 'availableType'], action.payload.target.value)
                .setIn(['workspaceData',
                  'events', positionNode[0],
                  'contents', positionNode[1],
                  'availableAtDetails', 'time'], 0);
            }
            return state
              .setIn(['workspaceData',
                'events', positionNode[0],
                'contents', positionNode[1],
                'availableAtDetails', 'availableType'], action.payload.target.value)
              .setIn(['workspaceData',
                'events', positionNode[0],
                'contents', positionNode[1],
                'availableAtDetails', 'time'], Date.now());
          // Content - Delay relative
          case 'delay-relative':
            return state
              .setIn(['workspaceData',
                'events', positionNode[0],
                'contents', positionNode[1],
                'availableAtDetails', 'time'], action.payload.target.value);
          // Content - Delay absolute
          case 'delay-absolute':
            return state
              .setIn(['workspaceData',
                'events', positionNode[0],
                'contents', positionNode[1],
                'availableAtDetails', 'time'], action.payload.target.value.valueOf());
          // Content - Start at
          case 'start-at':
            if (state.getIn(['currentNodeSelected', 'nodeType']) === NODE_END_OF_CONTENT) {
              return state
                .setIn(['workspaceData',
                  'events', positionParent[0],
                  'contents', positionParent[1],
                  'endOfContent', 'content', 'anchor'], action.payload.target.value);
            }
            return state
              .setIn(['workspaceData',
                'events', positionParent[0], 'contents', positionParent[1],
                'ctas', positionParent[2],
                'linkTo', 'content', 'anchor'], action.payload.target.value);
          // Call
          case 'call':
            return state
              .setIn(['workspaceData',
                'events', positionNode[0],
                'contents', positionNode[1],
                'endOfContent', 'call'], action.payload.target.value);
          // Website
          case 'website':
            return state
              .setIn(['workspaceData',
                'events', positionNode[0],
                'contents', positionNode[1],
                'endOfContent', 'url'], action.payload.target.value.trim());
          // Mail
          case 'mail-email':
            return state
              .setIn(['workspaceData',
                'events', positionNode[0],
                'contents', positionNode[1],
                'endOfContent', 'mail', 'email'], action.payload.target.value);
          case 'mail-subject':
            return state
              .setIn(['workspaceData',
                'events', positionNode[0],
                'contents', positionNode[1],
                'endOfContent', 'mail', 'subject'], action.payload.target.value);
          // CustomCTA
          case 'custom-cta':
            return state
              .setIn(['workspaceData',
                'events', positionNode[0],
                'contents', positionNode[1],
                'endOfContent', 'customCTA'], action.payload.target.value);
          // OwnAnchor
          case 'own-anchor':
            return state
              .setIn(['workspaceData',
                'events', positionNode[0],
                'contents', positionNode[1],
                'endOfContent', 'ownAnchor'], action.payload.target.value);
          // TriggerEvent
          case 'trigger-event':
            return state
              .setIn(['workspaceData',
                'events', positionNode[0],
                'contents', positionNode[1],
                'endOfContent', 'eventId'], action.payload.target.value);
          // JoinAudience
          case 'join-audience':
            return state
              .setIn(['workspaceData',
                'events', positionNode[0],
                'contents', positionNode[1],
                'endOfContent', 'segment'], action.payload.target.value);
          // ActivateBroadcast
          case 'activate-broadcast':
            return state
              .setIn(['workspaceData',
                'events', positionNode[0],
                'contents', positionNode[1],
                'endOfContent', 'broadcast'], action.payload.target.value);
          default:
            return state;
        }
      } else if (positionNode.length === 3) {
        switch (action.payload.target.name) {
          // Call
          case 'call':
            return state
              .setIn(['workspaceData',
                'events', positionNode[0],
                'contents', positionNode[1],
                'ctas', positionNode[2],
                'linkTo', 'call'], action.payload.target.value);
          // Website
          case 'website':
            return state
              .setIn(['workspaceData',
                'events', positionNode[0],
                'contents', positionNode[1],
                'ctas', positionNode[2],
                'linkTo', 'url'], action.payload.target.value.trim());
          // Mail
          case 'mail-email':
            return state
              .setIn(['workspaceData',
                'events', positionNode[0],
                'contents', positionNode[1],
                'ctas', positionNode[2],
                'linkTo', 'mail', 'email'], action.payload.target.value);
          case 'mail-subject':
            return state
              .setIn(['workspaceData',
                'events', positionNode[0],
                'contents', positionNode[1],
                'ctas', positionNode[2],
                'linkTo', 'mail', 'subject'], action.payload.target.value);
          // CustomCTA
          case 'custom-cta':
            return state
              .setIn(['workspaceData',
                'events', positionNode[0],
                'contents', positionNode[1],
                'ctas', positionNode[2],
                'linkTo', 'customCTA'], action.payload.target.value);
          // OwnAnchor
          case 'own-anchor':
            return state
              .setIn(['workspaceData',
                'events', positionNode[0],
                'contents', positionNode[1],
                'ctas', positionNode[2],
                'linkTo', 'ownAnchor'], action.payload.target.value);
          // TriggerEvent
          case 'trigger-event':
            return state
              .setIn(['workspaceData',
                'events', positionNode[0],
                'contents', positionNode[1],
                'ctas', positionNode[2],
                'linkTo', 'eventId'], action.payload.target.value);
          // JoinAudience
          case 'join-audience':
            return state
              .setIn(['workspaceData',
                'events', positionNode[0],
                'contents', positionNode[1],
                'ctas', positionNode[2],
                'linkTo', 'segment'], action.payload.target.value);
          // ActivateBroadcast
          case 'activate-broadcast':
            return state
              .setIn(['workspaceData',
                'events', positionNode[0],
                'contents', positionNode[1],
                'ctas', positionNode[2],
                'linkTo', 'broadcast'], action.payload.target.value);
          default:
            return state;
        }
      }
      return state;
    }

    // Toggle event modal
    case TOGGLE_EVENT_MODAL:
      return state.set('isOpenEventModal', !state.get('isOpenEventModal'));

    // Toggle error modal
    case TOGGLE_ERROR_MODAL:
      return state.set('isOpenErrorModal', !state.get('isOpenErrorModal'));

    // Toggle choose event modal
    case TOGGLE_CHOOSE_EVENT_MODAL:
      return state.set('isOpenChooseEventModal', !state.get('isOpenChooseEventModal'));

    // Toggle preview modal
    case TOGGLE_PREVIEW_MODAL:
      return state.set('isOpenPreviewModal', !state.get('isOpenPreviewModal'));

    // Toggle dragging
    case TOGGLE_DRAGGING:
      return state.set('isGlobalDragging', !state.get('isGlobalDragging'));

    // Handle change text in Search box
    case HANDLE_CHANGE_SEARCH:
      if (action.payload.target.value.length < 3) {
        return state
          .set('searchText', action.payload.target.value)
          .set('searchResult', state.get('contentLibrary'));
      }
      return state.set('searchText', action.payload.target.value);

    // Fetch content library
    case SEARCH_CONTENT_REQUEST:
      return state
        .set('isSearching', true)
        .set('isInProcessing', true);
    case SEARCH_CONTENT_SUCCESS:
      return state
        .set('searchResult', fromJS(action.searchResult))
        .set('isSearching', false)
        .set('isInProcessing', false);
    case SEARCH_CONTENT_FAILURE:
      return state
        .set('isSearching', false)
        .set('isInProcessing', false)
        .set('appError', fromJS(action.appError))
        .set('isOpenErrorModal', true);

    // Update content detail
    case UPDATE_CONTENT_REQUEST:
      return state
        .set('isUpdatingContent', true)
        .set('isInProcessing', true);
    // case UPDATE_CONTENT_SUCCESS:
    //   return state
    //     .setIn(['workspaceData', 'events', action.payload.eventIndex, 'contents'], fromJS(action.payload.newContents))
    //     .set('isUpdatingContent', false)
    //     .set('isInProcessing', false);
    case UPDATE_CONTENT_SUCCESS:
      return state
        .setIn(['workspaceData', 'events'], fromJS(action.newEvents))
        .set('isUpdatingContent', false)
        .set('isInProcessing', false);
    case UPDATE_CONTENT_FAILURE:
      return state
        .set('isUpdatingContent', false)
        .set('isInProcessing', false)
        .set('appError', fromJS(action.appError))
        .set('isOpenErrorModal', true);

    // Update events data
    case UPDATE_EVENTS_DATA:
      return state.setIn(['workspaceData', 'events'], fromJS(action.payload));

    // Fetch desktop player data
    case FETCH_DESKTOP_PLAYER_REQUEST:
      return state
        .set('desktopPlayerData', fromJS({}))
        .set('isFetchingDesktopPlayer', true)
        // .set('isOpenChooseEventModal', false)
        .set('isInProcessing', true)
        .set('isOpenPreviewModal', false);
    case FETCH_DESKTOP_PLAYER_SUCCESS:
      return state
        .set('desktopPlayerData', fromJS(action.desktopPlayerData))
        .set('isFetchingDesktopPlayer', false)
        .set('isOpenChooseEventModal', false)
        .set('isInProcessing', false)
        .set('isOpenPreviewModal', true);
    case FETCH_DESKTOP_PLAYER_FAILURE:
      return state
        .set('isFetchingDesktopPlayer', false)
        .set('isInProcessing', false)
        .set('isOpenChooseEventModal', false)
        .set('appError', fromJS(action.appError))
        .set('isOpenErrorModal', true)
        .set('isOpenPreviewModal', false);

    // Toggle event collapse
    case TOGGLE_EVENT_COLLAPSE:
      return state
        .setIn(
          ['workspaceData', 'events', action.payload.eventIndex, 'isCollapsed'],
          !state.getIn(['workspaceData', 'events', action.payload.eventIndex, 'isCollapsed'])
        );

    // Fetch list audiences
    case FETCH_AUDIENCES_REQUEST:
      return state
        .set('audiences', fromJS([]))
        .set('isFetchingAudiences', true)
        .set('isInProcessing', true);
    case FETCH_AUDIENCES_SUCCESS:
      return state
        .set('audiences', fromJS(action.audiences))
        .set('isFetchingAudiences', false)
        .set('isInProcessing', false);
    case FETCH_AUDIENCES_FAILURE:
      return state
        .set('isFetchingAudiences', false)
        .set('isInProcessing', false)
        .set('appError', fromJS(action.appError))
        .set('isOpenErrorModal', true);

    // Fetch list automated broadcast
    case FETCH_AUTOMATED_BROADCAST_REQUEST:
      return state
        .set('automatedBroadcasts', fromJS([]))
        .set('isFetchingAutomatedBroadcast', true)
        .set('isInProcessing', true);
    case FETCH_AUTOMATED_BROADCAST_SUCCESS:
      return state
        .set('automatedBroadcasts', fromJS(action.automatedBroadcasts))
        .set('isFetchingAutomatedBroadcast', false)
        .set('isInProcessing', false);
    case FETCH_AUTOMATED_BROADCAST_FAILURE:
      return state
        .set('isFetchingAutomatedBroadcast', false)
        .set('isInProcessing', false)
        .set('appError', fromJS(action.appError))
        .set('isOpenErrorModal', true);

    // Fetch tenant settings
    case FETCH_TENANT_SETTINGS_REQUEST:
      return state
        .set('tenantSettings', fromJS([]))
        .set('isFetchingTenantSettings', true)
        .set('isInProcessing', true);
    case FETCH_TENANT_SETTINGS_SUCCESS:
      return state
        .set('tenantSettings', fromJS(action.tenantSettings))
        .set('isFetchingTenantSettings', false)
        .set('isInProcessing', false);
    case FETCH_TENANT_SETTINGS_FAILURE:
      return state
        .set('isFetchingTenantSettings', false)
        .set('isInProcessing', false)
        .set('appError', fromJS(action.appError))
        .set('isOpenErrorModal', true);

    // Show error modal
    case SHOW_ERROR:
      return state
        .set('appError', fromJS(action.payload))
        .set('isOpenErrorModal', true);

    // DEFAULT
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/containers/program/reducer.js